import { render, staticRenderFns } from "./make-payment-content.vue?vue&type=template&id=513ebda6&scoped=true&"
import script from "./make-payment-content.vue?vue&type=script&lang=js&"
export * from "./make-payment-content.vue?vue&type=script&lang=js&"
import style0 from "./make-payment-content.vue?vue&type=style&index=0&id=513ebda6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513ebda6",
  null
  
)

export default component.exports